import React, { useState } from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { SectionHeading } from '../SectionHeading/SectionHeading';
import { OverviewDTO } from '../../../api/useOverviewQuery';
import { Alignment } from './components/Alignment/Alignment';
import { PendingItem } from './components/PendingItem/PendingItem';
import CodeCompareIcon from '../../img/code-compare.svg';
import { ToggleButton } from './Alignments.styles';

interface Props {
  data: OverviewDTO;
}

export const Alignments = ({ data }: Props) => {
  const [isManagingComparisons, setIsManagingComparisons] = useState(false);

  if (data.pendingInvites.length + data.pendingRequests.length + data.alignments.length === 0) {
    return null;
  }

  return (
    <Box as="section">
      <SectionHeading icon={<CodeCompareIcon />} mb="24">
        Your Comparisons
      </SectionHeading>

      <ToggleButton
        variant="subtleInactive"
        leftIcon={isManagingComparisons ? 'far fa-times-circle' : 'far fa-pencil'}
        onClick={() => {
          setIsManagingComparisons(state => !state);
        }}
        mx="auto"
        mb="24"
        css="display: block"
        aria-pressed={isManagingComparisons}
      >
        {isManagingComparisons ? 'Exit ' : ''}Manage Comparisons
      </ToggleButton>

      <Box display="flex" justifyContent="center" flexWrap="wrap" gridGap="24px 16px">
        {data.pendingInvites.map(pendingInvite => (
          <PendingItem key={pendingInvite.id} type="invite" item={pendingInvite} />
        ))}

        {data.pendingRequests.map(pendingRequest => (
          <PendingItem key={pendingRequest.id} type="request" item={pendingRequest} />
        ))}

        {data.alignments.map(alignment => (
          <Alignment
            key={alignment.id}
            alignment={alignment}
            data={data}
            showRemove={isManagingComparisons}
          />
        ))}
      </Box>
    </Box>
  );
};
